/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Router                } from '@angular/router';

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class ProfileAction
 *
 * @brief jump to the users profile page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProfileAction extends Action {

  constructor(
    private router:  Router,
    options: any = null
  ) {

    super({
      key:   'user.profile',
      type:  ActionType.User_Profile,
      label: 'My Profile',
      icon:  '<i class="fas fa-id-card"></i>',
      tip:   'Manage your preferences & history'
    });
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[ProfileAction] jumping to profile page...');

    this.router.navigate(['/profile']);
  }
}
